import { useState } from "react";
import Modal from "src/components/common/modal";
import { myOptions } from "src/components/personel/userForm";
//--------------------------------------------------------------------------------------------
export default function FleetForm({
    users, 
    keyword, 
    handleSubmit, 
    closeIt,
    shoulDisable, 
    postUrl,
    
    truckNumber, 
    location, 
    functionality, 
    background, 
    open, 
    department, 
    employee,
    type, 
    vin, 
    year, 
    make, 
    model, 
    licenseNumber, 
    trailer, 
    status,
}){
    const [curTruckNumber, setTruckNumber] = useState(truckNumber ?? "");
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"1400px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div className = "cssSeperateWhenWide pl-3 mb-2">
                <div className = "flex-grow-1 mr-3">
                    <input
                        className = "nodisplay" readOnly
                        name = "url" value = {postUrl}
                    />
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "truckNumber" className = "font-weight-bold required-field">Truck Number:</label>
                        <input
                            id = "truckNumber"
                            type = "text"
                            required
                            className = "form-control flex-grow-1 ml-3"
                            name = "truckNumber"
                            readOnly = {shoulDisable}
                            value = {curTruckNumber}
                            onChange = {e => setTruckNumber(e.currentTarget.value.replace(/\//g, "").replace(/ /g, "").replace(/\?/g, ""))}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "trailer" className = "font-weight-bold">is Trailer:</label>
                        <select
                            id = "trailer"
                            required
                            className = "form-control flex-grow-1 ml-3"
                            name = "trailer"
                            defaultValue = {trailer || ""}
                        >
                            <option value = "">Select</option>
                            <option value = "no">No</option>
                            <option value = "t">Trailer</option>
                            <option value = "hp">Hot Patch Trailer</option>
                        </select>
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "department" className = "font-weight-bold">Department:</label>
                        <select id = "department" className = "form-control flex-grow-1 ml-3" name = "department" defaultValue = {department || ""}>
                            <option value = "">Select</option>
                            {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                            <option>MTI</option>
                        </select>
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "location" className = "font-weight-bold">Region:</label>
                        <select id = "location" className = "form-control flex-grow-1 ml-3" name = "location" defaultValue = {location || ""}>
                            <option value = "">Select</option>
                            {myOptions.region.map((o, oi) => <option key = {oi}>{o}</option>)}
                        </select>
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "functionality" className = "font-weight-bold">Functionality:</label>
                        <input
                            id = "functionality"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            name = "functionality"
                            defaultValue = {functionality || ""}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "employee" className = "font-weight-bold">Employee:</label>
                        <select id = "employee" className = "form-control flex-grow-1 ml-3" name = "employee" defaultValue = {employee || ""}>
                            <option value = "">Select</option>
                            {users.map((u, k) => <option key = {k} value = {u.email}>{u.userName}</option>)}
                        </select>
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "open" className = "font-weight-bold">OPEN:</label>
                        <select id = "open" className = "form-control flex-grow-1 ml-3" name = "open" defaultValue = {open || ""}>
                            <option value = "">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "type" className = "font-weight-bold">Type:</label>
                        <select id = "type" name = "type" className = "form-control flex-grow-1 ml-3" defaultValue = {type || ""}>
                            <option value = "">Select</option>
                            <option>Hydro Vac Truck</option>
                            <option>Air Vac Truck</option>
                            <option>Dump Truck</option>
                            <option>Traffic Truck</option>
                            <option>No</option>
                        </select>
                    </div>
                </div>
                <div className = "flex-grow-1 mr-3">
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "licenseNumber" className = "font-weight-bold">License Number:</label>
                        <input
                            id = "licenseNumber"
                            type = "text"
                            name = "licenseNumber"
                            className = "form-control flex-grow-1 ml-3"
                            defaultValue = {licenseNumber || ""}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "vin" className = "font-weight-bold">VIN:</label>
                        <input
                            id = "vin"
                            type = "text"
                            name = "vin"
                            className = "form-control flex-grow-1 ml-3"
                            defaultValue = {vin || ""}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "year" className = "font-weight-bold">Year:</label>
                        <input
                            id = "year"
                            type = "text"
                            name = "year"
                            className = "form-control flex-grow-1 ml-3"
                            defaultValue = {year || ""}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "make" className = "font-weight-bold">Make:</label>
                        <input
                            id = "make"
                            type = "text"
                            name = "make"
                            className = "form-control flex-grow-1 ml-3"
                            defaultValue = {make || ""}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "model" className = "font-weight-bold">Model:</label>
                        <input
                            id = "model"
                            type = "text"
                            name = "model"
                            className = "form-control flex-grow-1 ml-3"
                            defaultValue = {model || ""}
                        />
                    </div>
                    <div className = "mt-2 d-flex align-items-center">
                        <label htmlFor = "status" className = "font-weight-bold">Status:</label>
                        <select
                            id = "status"
                            required
                            className = "form-control flex-grow-1 ml-3"
                            name = "status"
                            defaultValue = {status !== '' ? status : ""}
                        >
                            <option value = "">Select</option>
                            <option value = "1">Active</option>
                            <option value = "0">Inactive</option>
                        </select>
                    </div>
                </div>
                <div className = "flex-grow-1 mr-3">
                    <label htmlFor = "background" className = "font-weight-bold d-inline-block mt-2">Background:</label>
                    <textarea id = "background" name = "background" className = "form-control w-100 mt-2" defaultValue = {background || ""} rows = {13}/>
                </div>
            </div>
        </Modal>
    )
}